import React from 'react'
import './success.scss'
import { ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import Loading from '../../common/loading/loading'
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component'

class HomeworkAssign extends React.Component {
  state = {
    homeworkDetails: {
      count: 0
    }
  }

  constructor(props) {
    super(props)
    this.state.homeworkDetails = this.props.homeworkDetail
  }

  componentDidMount() { }

  render() {
    return (
      <>
        <div className='container-fluid invitation-success'>
          <div className='loader'>
            {this.state.loading && <Loading />}
          </div>
          <div className='row no-gutters'>
            <div className='col-12 p-2 py-3'>
              <img alt='cw-logo' src={getImageSource(ImageConstants.CW_LOGO)} />
            </div>
          </div>
          {!this.state.loading && (
            <div className='row mt-2'>
              <div className='col-lg-6'>
                <div className='homework-success-left'>
                  <img alt=""
                    src={getImageSource(ImageConstants.HOMEWORK_SUCCESS_LEFT)}
                  />
                  <div className='homework-success-left-content'>
                    <div>
                      You will receive a WhatsApp message soon. Please forward that message to all your students to get them to sign up.
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-6'>
                <div className='homework-success-right'>
                  <img
                    alt=""
                    src={getImageSource(ImageConstants.HOMEWORK_SUCCESS_RIGHT)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    )
  }
}

export default HomeworkAssign
